import { gsap } from 'gsap'

export class InterviewLowerKv {
  constructor() {
    if (document.getElementById('js-interview_lower_kv') === null) return

    const kvAnim = () => {
      const tl = gsap.timeline()
      tl.fromTo(
        '.p-interview_lower_kv__pic',
        {
          opacity: 0,
          onComplete: () => {
            document.getElementById('js-interview_lower_kv').classList.add('is-act')
          },
        },
        {
          opacity: 1,
          duration: 1,
        }
      )
      tl.fromTo('.p-interview_lower_kv__circle', { opacity: 0, scale: 1.2 }, { opacity: 1, scale: 1, duration: 1 })
      tl.fromTo('.p-interview_lower_kv__copy', { opacity: 0, y: 10 }, { opacity: 1, x: 0 }, '<')
    }

    window.addEventListener('load', () => {
      kvAnim()
    })
  }
}
